/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import baseImageGallery from '@salesforce/retail-react-app/app/theme/components/project/image-gallery'

export default {
    ...baseImageGallery,
    baseStyle: {
        ...baseImageGallery.baseStyle,
        videoGalleryWrapper: {
            position: 'relative',
            paddingBottom: '150%',
            overflow: 'hidden'
        },
        videoGalleryElement: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: 'calc(100% + 2px)',
            height: 'calc(100% + 2px)',
            margin: '-1px',
            objectFit: 'cover',
            display: 'block'
        }
    },
    parts: [...baseImageGallery.parts, 'videoGalleryWrapper', 'videoGalleryElement']
}
